import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from "@angular/forms"


import { AlertService } from '../../providers/alert.service';
import { UsuarioService } from '../../services/usuario.service';
import { SessionService } from '../../providers/session.service'

@Component({
	selector: 'app-troca-senha',
	templateUrl: './troca-senha.component.html',
	styleUrls: ['./troca-senha.component.scss', '../../assets/less/all.less']
})
export class TrocaSenhaComponent implements OnInit {
	public senha_form: FormGroup
	senha: null;
	id;
	loading;
	constructor(
		public usuario_service: UsuarioService,
		public session_service: SessionService,
		public formBuilder: FormBuilder,
		public alerts: AlertService) {
		this.senha_form = this.formBuilder.group({
			senha: ['', Validators.required],
		})

	}

	ngOnInit() {
		this.getId()
	}

	getId(){
		this.id = this.session_service.getId()
	}

	alteraSenha() {

        this.loading = true;

        this.usuario_service.resetSenha(this.id, this.senha)
            .then(res => {
                if (res) {
                    this.loading = false;
                    this.alerts.openAlert('Tudo certo!', 'Senha alterada com sucesso');
                } else {
                    this.loading = false;
                    this.alerts.openAlert('Ops,', 'Ocorreu um erro, tente novamente mais tarde');
                }
            })
            .catch(error => {
                this.loading = false;
                console.log(error)
            })

    }

}
